import request from '@/utils/request'
import { getToken } from '../utils/auth'

// 组织数据
export function queryorg () {
  return request({
    url: '/queryorg',
    method: 'post',
    params: { token: getToken() }
  })
}
// 查询下级组织
export function queryChildrenOrgByOrgId (data) {
  return request({
    url: '/querychirdrenorgbyorgid',
    method: 'post',
    params: { token: getToken() },
    data: {
      orgid: data.orgid
    }
  })
}
// 通过机构实体ID查询下级组织
export function queryChildrenOrgByEid (data) {
  return request({
    url: '/querychirdrenorgbyeid',
    method: 'post',
    params: { token: getToken() },
    data: { eid: data.eid }
  })
}
export function addorg (data) {
  return request({
    url: '/addorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新组织
export function updateorg (data) {
  return request({
    url: '/updateorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除组织
export function deleteorg (data) {
  return request({
    url: '/deleteorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 根据组织id查询小区
export function querycommunitybyorgids (data) {
  return request({
    url: '/querycommunitybyorgids',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 按组织查询 FM 信息
export function queryfmdevicebyorg (data) {
  return request({
    url: '/queryfmdevicebyorg',
    method: 'post',
    params: { token: getToken(), size: data.size, page: data.page },
    data: {
      oid: data.oid
    }
  })
}
// 删除组织 FM 信息
export function deletefmdevicebyorg (data) {
  return request({
    url: '/deletefmdevicebyorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 按照组织设置FM
export function addfmdevicebyorg (data) {
  return request({
    url: '/addfmdevicebyorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 按照家庭查找家庭联系人
export function queryfamilypersonbyhid (data) {
  return request({
    url: '/queryfamilypersonbyhid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/organizer.js